import { SW_ARRIVE_INDEX, SW_BEATS } from "../lib/beats";
import WalkIn from "../components/WalkIn";

/** Stageward: Clarity Hall, four beats from the steps to the Graffiti Wall. */
export default function StagewardWalk() {
  return (
    <WalkIn
      beats={SW_BEATS}
      realm="stageward"
      pathPrefix="/stageward/walk"
      arriveIndex={SW_ARRIVE_INDEX}
      arriveTo="/stageward"
      arriveLabel="Put it down"
      skipLabel="Straight to the wall"
      placeName="Clarity Hall"
      choiceLine="Walk yourself in, or let the Hall carry you?"
    />
  );
}
